module.exports = __webpack_public_path__ + "step1.12630ab.png";